/** @format */

import { styled } from "@mui/material/styles";
import Page from "../../components/Page";
import { Card, Container, Stack, TextField, Typography } from "@mui/material";
import { Form, FormikProvider, useFormik } from "formik";
import Iconify from "../../components/Iconify";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import * as yup from "yup";
import User from "../../dao/User";

import Swal from "../../reusables/CustomSwal";
import logo from "../../static/logo-infomedia.png"; // relative path to image
import { timeout } from "../../utils/utilitys";

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  display: "flex",
  minHeight: "100vh",
  flexDirection: "column",
  justifyContent: "center",
  padding: theme.spacing(12, 0),
}));

export default function SignUp() {
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const onFormSubmit = async (values) => {
    await setIsLoading(true);

    try {
      await User.register(values);
      // let response = await User.register(values);
      // await console.log(response);
      await timeout(2000);
      await setIsLoading(false);
      await navigate("/confirm", { state: values.email });
    } catch (e) {
      let errorMessage = "An error occurred.";
      if (e.code === "EMAIL_NOT_FOUND" || e.code === "USER_PASSWORD_WRONG") {
        errorMessage = "Invalid credentials";
      }
      await Swal.fire({
        title: "Error",
        text: errorMessage ? errorMessage : "An error Occured",
        icon: "error",
      });
      await setIsLoading(false);
    }
  };

  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

  // "first_name": "Donny",
  // "last_name": "Darko",
  // "email": "donny@gmailx.com",
  // "phone_number": "6282217788203",
  // "job_title": "Prof IT"
  const RegisterSchema = yup.object().shape({
    first_name: yup.string().required("First name is required"),
    last_name: yup.string().required("Last name is required "),
    email: yup
      .string()
      .email("Wrong email format")
      .min(3, "Minimum 3 symbols")
      .max(128, "Maximum 128 symbols")
      .required("email is required"),
    phone_number: yup
      .string()
      .matches(phoneRegExp, "Phone number is not valid")
      .required("Phone number is required"),
    job_title: yup.string().required("Job title is required"),
  });

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      phone_number: "",
      job_title: "",
    },
    validationSchema: RegisterSchema,
    onSubmit: (values) => onFormSubmit(values),
  });

  const { values, errors, touched, handleSubmit, handleChange } = formik;

  return (
    <RootStyle title="Registration">
      <Container maxWidth="sm">
        <ContentStyle>
          <Stack sx={{ mb: 5 }}>
            <img src={logo} alt="logo-infomedia" />
          </Stack>
          <Card sx={{ p: 4 }}>
            <FormikProvider value={formik}>
              <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                <Stack spacing={3} sx={{ mb: 5 }}>
                  <Stack>
                    <Typography variant="h5" sx={{ textAlign: "center" }}>
                      Create account
                    </Typography>
                  </Stack>
                  <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                    <TextField
                      fullWidth
                      label="First Name"
                      name="first_name"
                      onChange={handleChange}
                      value={values.first_name}
                      InputLabelProps={{ shrink: true }}
                      error={errors.first_name && touched.first_name}
                      helperText={
                        errors.first_name && touched.first_name
                          ? errors.first_name
                          : ""
                      }
                    />

                    <TextField
                      fullWidth
                      label="Last Name"
                      name="last_name"
                      onChange={handleChange}
                      value={values.last_name}
                      InputLabelProps={{ shrink: true }}
                      error={errors.last_name && touched.last_name}
                      helperText={
                        errors.last_name && touched.last_name
                          ? errors.last_name
                          : ""
                      }
                    />
                  </Stack>
                  <TextField
                    fullWidth
                    label="Email"
                    autoComplete="email"
                    name={"email"}
                    onChange={handleChange}
                    value={values.email}
                    InputLabelProps={{ shrink: true }}
                    error={errors.email && touched.email}
                    helperText={
                      errors.email && touched.email ? errors.email : ""
                    }
                  />
                  <TextField
                    fullWidth
                    label="Phone number"
                    autoComplete="tel"
                    onChange={handleChange}
                    name="phone_number"
                    value={values.phone_number}
                    InputLabelProps={{ shrink: true }}
                    error={errors.phone_number && touched.phone_number}
                    helperText={
                      errors.phone_number && touched.phone_number
                        ? errors.phone_number
                        : ""
                    }
                  />
                  <TextField
                    fullWidth
                    label="Job title"
                    name={"job_title"}
                    onChange={handleChange}
                    value={values.job_title}
                    InputLabelProps={{ shrink: true }}
                    error={errors.job_title && touched.job_title}
                    helperText={
                      errors.job_title && touched.job_title
                        ? errors.job_title
                        : ""
                    }
                  />

                  <LoadingButton
                    size="large"
                    type="submit"
                    style={{
                      marginTop: 30,
                    }}
                    variant="contained"
                    loading={isLoading}
                  >
                    <Iconify
                      icon="eva:save-outline"
                      width={22}
                      height={22}
                      sx={{ marginRight: 1 }}
                    />
                    Sign up
                  </LoadingButton>
                </Stack>
              </Form>
            </FormikProvider>
            <Typography>
              Already have account?{" "}
              <span
                onClick={() => navigate("/login")}
                style={{ color: "blue", cursor: "pointer", fontWeight: "700" }}
              >
                Login
              </span>
            </Typography>
          </Card>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
